import { MessageResponse } from "@/generated-api";
import { ImagesIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TimeReadStatus from "./TimeReadStatus";
import { useTranslation } from "@/hooks/useTranslation";

export default function PhotosSharedChatBubble({
  counterpartyId,
  message,
}: {
  counterpartyId: string;
  message: MessageResponse;
}) {
  const navigate = useNavigate();
  const counterparty = message.sender_id === counterpartyId;
  const t = useTranslation();

  return (
    <div
      className={`${
        counterparty
          ? "bg-white text-black border-gray-500 border-2"
          : "bg-zinc-800 text-white border-white border"
      } p-3 rounded-2xl inline-flex items-center gap-3 hover:cursor-pointer select-none`}
      onClick={() => {
        counterparty
          ? navigate("/profile/" + counterpartyId)
          : navigate("/profile");
      }}
    >
      <ImagesIcon className="h-6 w-6 shrink-0" />
      <div className="relative">
        <p className="text-base break-words whitespace-pre-wrap max-w-xs lg:max-w-md">
          {t.PHOTO_SHARING.LABELS.SHARED_MESSAGE(
            counterparty ? message.content : undefined
          )}
          <span
            className={`inline-block ${
              counterparty
                ? "w-[2.4rem]"
                : message.read_at
                ? "w-[3.7rem]"
                : "w-[3.4rem]"
            }`}
          ></span>
        </p>
        <TimeReadStatus message={message} counterparty={counterparty} />
      </div>
    </div>
  );
}
